import React from 'react';

const RadioButtonGroupContext = React.createContext({
  isGroup: false,
  groupName: '',
  groupRequired: false,
  groupDisabled: false
});

export const RadioButtonGroupProvider = RadioButtonGroupContext.Provider;
export default RadioButtonGroupContext;
